import { createEvent } from 'effector';

export const showSideMenu = createEvent();

export const hideSideMenu = createEvent();

export const showAppModal = createEvent<{
  content: React.ReactElement;
  styleOverrides?: string;
  timeout?: number;
}>();

export const hideAppModal = createEvent<void>();

export const setIsValetPaymentScreenOpen = createEvent<{ open: boolean; visitId: number }>();

export const setIsValetCancelRequestScreenOpen = createEvent<{
  open: boolean;
  visitId: number;
}>();

export const setHideActiveVisitValidationScanner = createEvent<{
  hide: boolean;
  visitId: number;
}>();

// TODO: remove this when we have a better solution for the parking pass receipt
export const setShowParkingPassReceiptSheet = createEvent<boolean>();
